/**
 * W3C traceparent generation for distributed tracing. Compatible with NestJS OpenTelemetry.
 * Format: 00-{trace-id}-{parent-span-id}-{flags} (32 hex trace-id, 16 hex span-id).
 */

const VERSION = '00';
const FLAGS_SAMPLED = '01';

function randomHex(bytes: number): string {
  const array = new Uint8Array(bytes);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(array);
  } else {
    for (let i = 0; i < bytes; i++) {
      array[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(array)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Generates a new traceparent for the current request (one per outbound call).
 * trace-id: 128-bit (32 hex), parent-span-id: 64-bit (16 hex), flags: 01 (sampled).
 */
export function getTraceparent(): string {
  const traceId = randomHex(16);
  const parentSpanId = randomHex(8);
  return `${VERSION}-${traceId}-${parentSpanId}-${FLAGS_SAMPLED}`;
}
